import Vue from 'vue';
import * as Sentry from '@sentry/vue';

/**
 * Returns whether Sentry should be active in the browser.
 */
export function isSentryEnabled() {
	const dsn = process.env.VUE_APP_SENTRY_DSN;
	if (!dsn) return false;
	if (process.env.NODE_ENV === 'production') return true;
	return process.env.VUE_APP_SENTRY_IN_DEVELOPMENT === 'true';
}

/**
 * Returns whether console warn/error should be forwarded to Sentry Logs.
 */
export function isSentryLogsEnabled() {
	if (!isSentryEnabled()) return false;
	return process.env.VUE_APP_SENTRY_LOGS_ENABLED !== 'false';
}

/**
 * Trace sample rate. Production default 0.002. Override with VUE_APP_SENTRY_TRACES_SAMPLE_RATE (0–1).
 * Override with VUE_APP_SENTRY_TRACES_SAMPLE_RATE (0–1).
 * @returns {number}
 */
function tracesSampleRate() {
	const fallback = process.env.NODE_ENV === 'production' ? 0.002 : 0.1;
	const raw = process.env.VUE_APP_SENTRY_TRACES_SAMPLE_RATE;
	if (raw == null || raw === '') return fallback;
	const parsed = Number(raw);
	if (!Number.isFinite(parsed) || parsed < 0 || parsed > 1) return fallback;
	return parsed;
}

if (isSentryEnabled()) {
	const sentryLogsEnabled = isSentryLogsEnabled();
	const integrations = [
		Sentry.replayIntegration({
			maskAllText: false,
			maskAllInputs: true,
		}),
	];
	if (sentryLogsEnabled) {
		integrations.unshift(Sentry.consoleLoggingIntegration({ levels: ['warn', 'error'] }));
	}

	Sentry.init({
		Vue,
		dsn: process.env.VUE_APP_SENTRY_DSN,
		sendDefaultPii: true,
		enableLogs: sentryLogsEnabled,
		integrations,
		sampleRate: process.env.NODE_ENV === 'production' ? 0.01 : 0.2,
		tracesSampleRate: tracesSampleRate(),
		profileSessionSampleRate: process.env.NODE_ENV === 'production' ? 0.001 : 0.1,
		replaysSessionSampleRate: 0.01,
		replaysOnErrorSampleRate: 1.0,
	});
}
